import { useTranslation } from "react-i18next";

import { IBillingPayment } from "../../../../types/billings";
import { formatCurrency } from "../../../../utils/currency";
import { getStringFromISOString } from "../../../../utils/dateHandler";
import { BillingCardContainer } from "../BillingCardContainer/BillingCardContainer";
import { BillingLabelValue, BillingLabelValueSize } from "../BillingLabelValue";
import { BillingPaymentButtons } from "../BillingPaymentButtons/BillingPaymentButtons";

import styles from "./BillingPaymentQuarterCard.module.scss";

interface BillingPaymentQuarterCardProps {
  payment: IBillingPayment;
  dueDate: string;
  isDisabled?: boolean;
}

export const BillingPaymentQuarterCard = ({ payment, dueDate, isDisabled = false }: BillingPaymentQuarterCardProps) => {
  const { t } = useTranslation();

  return (
    <BillingCardContainer className={styles.container}>
      <div className={styles.header}>
        <p className={styles.label}>{t(`collectionPoint.billingPaymentQuarterCard.period.${payment.period}`)}</p>
        <BillingPaymentButtons paymentDate={payment.paymentDate} period={payment.period} isDisabled={isDisabled} />
      </div>
      <div className={styles.body}>
        <BillingLabelValue
          value={formatCurrency(payment.amount ?? 0)}
          label={t("collectionPoint.billingPaymentQuarterCard.depositAmount")}
          valueSize={BillingLabelValueSize.Large}
        />
        <BillingLabelValue
          value={getStringFromISOString(dueDate)}
          label={t("collectionPoint.billingPaymentAnnualCard.dueDate")}
        />
      </div>
    </BillingCardContainer>
  );
};
